import {
  CONFIRM_MODAL_ACTION,
  CONFIRM_MODAL_ACTION_SUCCESS,
  CONFIRM_MODAL_ACTION_ERROR,
} from "./actionTypes"

const initialState = {
  responseAction: "",
  loadingAction: false,
  errorAction: "",
}

const ConfirmModal = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_MODAL_ACTION:
      state = {
        ...state,
        loadingAction: true,
        responseAction: "",
        errorAction: "",
      }
      break
    case CONFIRM_MODAL_ACTION_SUCCESS:
      state = {
        ...state,
        loadingAction: false,
        responseAction: action.payload.data
      }
      break
    case CONFIRM_MODAL_ACTION_ERROR:
      state = {
        ...state,
        loadingAction: false,
        errorAction: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default ConfirmModal
